import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { IconCheckFill, IconLocked, Text, tokens } from '@fhs/ui';
import { Nullable } from '@rbi-ctg/frontend';

interface Props {
  enabled?: Nullable<boolean>;
  label: string;
  style?: StyleProp<ViewStyle>;
}

export function PointsBadge({ enabled, label, style }: Props) {
  return (
    <View style={[styles.container, style]}>
      {enabled ? <IconCheckFill color={tokens.colors.$success} /> : <IconLocked />}
      <Text.Ui size="sm" weight="semibold" style={styles.label}>
        {label}
      </Text.Ui>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 4,
    backgroundColor: tokens.colors.$houseLight,
    flexDirection: 'row',
    alignSelf: 'flex-start',
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  label: {
    marginLeft: 4,
  },
});
